var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, EventEmitter, Output, Inject } from '@angular/core';
import * as _ from 'lodash';
import { VariableValueType } from '../comm/variable-value-type';
import { RelationType } from '../comm/relation-type';
import { WordConditionModel } from './word-condition-model';
import { VariableValueLogicModel } from '../comm/variable-value-logic-model';
import { WordExceptBHDataType } from '../../../../core/variable/flag-data-type';
import { DataMonitorPermission } from '../../../../core/variable/data-monitor-permission';
import { VariableName } from '../../../../core/variable/variable-name';
import { VARIABLE_SERVICE } from '../../../../core/variable/variable.service';
import { ConfigureComponentBase } from '../../../../../../shared/configure-component-base';
import { RelationalOperator } from '../comm/relational-operator';
var WordConditionComponent = /** @class */ (function (_super) {
    __extends(WordConditionComponent, _super);
    function WordConditionComponent(injector, comparatorTypeOptionService, variableTypeOptionService, relationTypeOptionService, variableService) {
        var _this = _super.call(this, injector) || this;
        _this.comparatorTypeOptionService = comparatorTypeOptionService;
        _this.variableTypeOptionService = variableTypeOptionService;
        _this.relationTypeOptionService = relationTypeOptionService;
        _this.variableService = variableService;
        _this.variableNameChangeEvent = new EventEmitter();
        _this.dataType = WordExceptBHDataType;
        _this.readModel = DataMonitorPermission.Read;
        _this.ralationType = RelationType;
        _this.variableValueType = VariableValueType;
        _this.comparatorTypes = _this.comparatorTypeOptionService.getOptions();
        _this.variableTypes = _this.variableTypeOptionService.getOptions();
        _this.relationTypes = _this.relationTypeOptionService.getOptions();
        _this.wordCondition = new WordConditionModel('', '', RelationType.None, new VariableValueLogicModel(VariableValueType.Constant, RelationalOperator.GreaterThan, undefined, undefined, 0, 0), 0, undefined);
        return _this;
    }
    Object.defineProperty(WordConditionComponent.prototype, "currentVariableId", {
        get: function () {
            return this._currentVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentVariableId)) {
                return;
            }
            this._currentVariableId = v;
            delete this.wordCondition.dataSourceCode;
            delete this.wordCondition.variableGroupName;
            this.wordCondition.variableName = v ? v.name : '';
            this.wordCondition.variableVersion = v ? v.variableVersion : undefined;
            this.variableNameChangeEvent.emit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WordConditionComponent.prototype, "currentBaseVariableId", {
        get: function () {
            return this._currentBaseVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentVariableId)) {
                return;
            }
            this._currentBaseVariableId = v;
            var baseValue = this.wordCondition.baseVariableValue;
            if (baseValue) {
                delete this.wordCondition.baseVariableValue.dataSourceCode;
                delete this.wordCondition.baseVariableValue.variableGroupName;
                baseValue.variableName = v ? v.name : '';
                baseValue.variableVersion = v ? v.variableVersion : undefined;
            }
            this.variableNameChangeEvent.emit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WordConditionComponent.prototype, "currentRelationVariableId", {
        get: function () {
            return this._currentRelationVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentVariableId)) {
                return;
            }
            this._currentRelationVariableId = v;
            var realtionValue = this.wordCondition.realtionVariableValue;
            if (realtionValue) {
                delete this.wordCondition.realtionVariableValue.dataSourceCode;
                delete this.wordCondition.realtionVariableValue.variableGroupName;
                realtionValue.variableName = v ? v.name : '';
                realtionValue.variableVersion = v ? v.variableVersion : undefined;
            }
            this.variableNameChangeEvent.emit();
        },
        enumerable: true,
        configurable: true
    });
    WordConditionComponent.prototype.onChangedAVariableType = function (value) {
        if (value !== VariableValueType.Variable) {
            this.currentBaseVariableId = undefined;
        }
    };
    WordConditionComponent.prototype.onChangedBVariableType = function (value) {
        if (value !== VariableValueType.Variable) {
            this.currentRelationVariableId = undefined;
        }
    };
    WordConditionComponent.prototype.onChangedRelationshipType = function (option) {
        // eslint-disable-next-line eqeqeq
        if (option == RelationType.None) {
            this._currentRelationVariableId = undefined;
            this.wordCondition.realtionVariableValue = undefined;
        }
        else {
            if (!this.wordCondition.realtionVariableValue) {
                this.wordCondition.realtionVariableValue =
                    new VariableValueLogicModel(VariableValueType.Constant, RelationalOperator.LessThan, undefined, undefined, 0, 0);
            }
        }
        this.variableNameChangeEvent.emit();
    };
    WordConditionComponent.prototype.isVariableNameEmpty = function () {
        var isEmpty = false;
        isEmpty = !this.wordCondition.variableName;
        if (this.wordCondition.baseVariableValue &&
            Number(this.wordCondition.baseVariableValue.valueType) === VariableValueType.Variable) {
            if (!this.wordCondition.baseVariableValue.variableName) {
                isEmpty = true;
            }
        }
        if (this.wordCondition.realtionVariableValue &&
            Number(this.wordCondition.realtionVariableValue.valueType) === VariableValueType.Variable) {
            if (!this.wordCondition.realtionVariableValue.variableName) {
                isEmpty = true;
            }
        }
        return isEmpty;
    };
    WordConditionComponent.prototype.getCondition = function () {
        if (this.wordCondition.baseVariableValue.valueType === VariableValueType.Constant
            && !this.wordCondition.baseVariableValue.constValue) {
            this.wordCondition.baseVariableValue.constValue = 0;
        }
        if (this.wordCondition.realtionVariableValue
            && this.wordCondition.realtionVariableValue.valueType === VariableValueType.Constant
            && !this.wordCondition.realtionVariableValue.constValue) {
            this.wordCondition.realtionVariableValue.constValue = 0;
        }
        return this.wordCondition;
    };
    WordConditionComponent.prototype.setCondition = function (wordCondition) {
        this.wordCondition = new WordConditionModel(wordCondition.variableName, wordCondition.variableGroupName, wordCondition.relationType, new VariableValueLogicModel(wordCondition.baseVariableValue.valueType, wordCondition.baseVariableValue.operator, wordCondition.baseVariableValue.variableName, wordCondition.baseVariableValue.variableGroupName, wordCondition.baseVariableValue.constValue, wordCondition.baseVariableValue.dataSourceCode, wordCondition.baseVariableValue.variableVersion), wordCondition.dataSourceCode);
        if (wordCondition.realtionVariableValue) {
            this.wordCondition.realtionVariableValue =
                new VariableValueLogicModel(wordCondition.realtionVariableValue.valueType, wordCondition.realtionVariableValue.operator, wordCondition.realtionVariableValue.variableName, wordCondition.realtionVariableValue.variableGroupName, wordCondition.realtionVariableValue.constValue, wordCondition.realtionVariableValue.dataSourceCode, wordCondition.realtionVariableValue.variableVersion);
        }
        if (wordCondition.variableVersion) {
            this.wordCondition.variableVersion = wordCondition.variableVersion;
        }
        this.setVariable();
        var baseValue = this.wordCondition.baseVariableValue;
        this.setBaseVariable(baseValue);
        var realtionValue = this.wordCondition.realtionVariableValue;
        this.setRelationVariable(realtionValue);
        this.variableNameChangeEvent.emit();
    };
    WordConditionComponent.prototype.setVariable = function () {
        var _this = this;
        if (this.wordCondition.variableVersion) {
            this._currentVariableId = VariableName.tryParse(this.wordCondition.variableName, this.wordCondition.variableVersion);
        }
        else if (!_.isNil(this.wordCondition.dataSourceCode)) {
            this.variableService.getVariableName(this.wordCondition.dataSourceCode, this.wordCondition.variableName, this.wordCondition.variableGroupName).subscribe(function (value) {
                _this._currentVariableId = value;
            });
        }
    };
    WordConditionComponent.prototype.setBaseVariable = function (baseValue) {
        var _this = this;
        if (baseValue) {
            if (baseValue.variableVersion) {
                this._currentBaseVariableId = VariableName.tryParse(baseValue.variableName, baseValue.variableVersion);
            }
            else if (!_.isNil(baseValue.dataSourceCode)) {
                this.variableService.getVariableName(baseValue.dataSourceCode, baseValue.variableName, baseValue.variableGroupName).subscribe(function (value) {
                    _this._currentBaseVariableId = value;
                });
            }
        }
    };
    WordConditionComponent.prototype.setRelationVariable = function (realtionValue) {
        var _this = this;
        if (realtionValue) {
            if (realtionValue.variableVersion) {
                this._currentRelationVariableId = VariableName.tryParse(realtionValue.variableName, realtionValue.variableVersion);
            }
            else if (!_.isNil(realtionValue.dataSourceCode)) {
                this.variableService.getVariableName(realtionValue.dataSourceCode, realtionValue.variableName, realtionValue.variableGroupName).subscribe(function (value) {
                    _this._currentRelationVariableId = value;
                });
            }
        }
    };
    __decorate([
        Input()
    ], WordConditionComponent.prototype, "configureId", void 0);
    __decorate([
        Output()
    ], WordConditionComponent.prototype, "variableNameChangeEvent", void 0);
    WordConditionComponent = __decorate([
        Component({
            selector: 'word-condition',
            styles: [".modal-content { width: 600px; } .row.no-gutter { margin-left: 5; margin-right: 0; } .row.no-gutter>[class*='col-'] { padding-right: 0; padding-left: 0; } .margin-top-5 { margin-top: 5px; } .condition-input{ padding-left:0px; padding-right:0px; height:30px } .condition-input-value{ flex: 0 0 37%; max-width: 37%; padding-right:0px; } .input-common{ padding:0; height:30px; } .i-required{ margin-right: 5px; color:red; display: inline-block; } .i-required-longer { color:red; position: relative; left: 0px; } .data-source-combo select{ width:100%; } .read-value,.variable-select{ width: 60px; display: inline-block; } .read-value{ width: 80px; float: left; } .sign-select,.variable-select{ margin-left: 10px; float: left; } .sign-select{ width: 100px; } .variable-input{ width: 115px; border: 1px solid #d7dbe5; height: 30px; margin-left: 10px; padding: 0 10px; } .logic-select{ width: 100px; } .logic-select>select{ width: 100px!important; border-color: #d7dbe5; } .variable-selector{ position: relative; left: 80px; width:calc(100% - 85px) ; height: 30px; display: inline-block; } .required-body{ width: 485px; } .label-width-wordOrBitCondition{ width: 80px; height: 30px; } .input-width-wordOrBitCondition{ width: calc(100% - 85px); } .interval{ margin-top: 10px; } .fe-transverse-component{ position: relative; } .variable-input-i{ position: absolute; right: -12px; } .variable-selector-i{ position: absolute; top: 5px; left: -77px; } .condition{ padding-left:10px; box-sizing: border-box;  } .word-condition .fe-transverse-title,.bit-condition .fe-transverse-title{ margin-right: 0; } .word-condition-input{ width: calc(100% - 85px); } .warn-color{ color: red; margin-left: 80px; } .default-input{ height: 30px; border: 1px solid #d7dbe5; } .bitwise-label{ width: 100px; } .bitwise-variable{ width: calc(100% - 205px); } .bitwise-bitIndex{ width: 110px; height: 30px; } .point{ height: 30px; float: left; width: 10px; text-align: center; }"],
            template: "<div class=\"word-condition\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-transverse-title label-width-wordOrBitCondition\"> <i class=\"i-required-longer\">*</i> {{lc('Variable')}}： </div> <div class=\"fe-transverse-component input-width-wordOrBitCondition\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentVariableId\" [dataType]=\"dataType\" [readWriteModel]=\"readModel\"></variable-selector> </div> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-transverse-title label-width-wordOrBitCondition condition\">{{lc('Condition')}}</div> <div class=\"fe-transverse-component clearfix word-condition-input\"> <div class=\"read-value\">{{lc('ReadValue')}}</div> <select name=\"aComparator\" [(ngModel)]='wordCondition.baseVariableValue.operator' class=\"variable-select\"> <option *ngFor=\"let option of comparatorTypes \" [value]=\"option.key \">{{option.name}}</option> </select> <select name=\"aVariable \" [(ngModel)]='wordCondition.baseVariableValue.valueType' (change)=\"onChangedAVariableType($event.target.value)\" class=\"sign-select\"> <option *ngFor=\"let option of variableTypes \" [value]=\"option.key \">{{option.name}}</option> </select> <div *ngIf=\"wordCondition.baseVariableValue.valueType==0\"> <input type=\"number\" name=\"constantAValue\" [(ngModel)]=\"wordCondition.baseVariableValue.constValue\" class=\"variable-input\"> <i class=\"i-required variable-input-i\">*</i> </div>     </div> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"variable-selector clearfix\" *ngIf=\"wordCondition.baseVariableValue.valueType==1\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentBaseVariableId\" [dataType]=\"dataType\" [readWriteModel]=\"readModel\"></variable-selector> <i class=\"i-required variable-selector-i\">*</i> </div> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"variable-selector clearfix\"> <div class=\"logic-select\"> <select name=\"relation\" [(ngModel)]=\"wordCondition.relationType \" (change)=\"onChangedRelationshipType($event.target.value)\"> <option *ngFor=\"let option of relationTypes \" [value]=\"option.key \">{{option.name}}</option> </select> </div> </div> </div> <div class=\"fe-transverse-label interval required-body clearfix\" *ngIf=\"wordCondition.relationType!=0 \"> <div class=\"fe-transverse-title  label-width-wordOrBitCondition\"> </div> <div class=\"fe-transverse-component  word-condition-input\"> <div class=\"read-value\"> {{lc('ReadValue')}} </div> <select name=\"bComparator\" [(ngModel)]=\"wordCondition.realtionVariableValue.operator\" class=\"variable-select\"> <option *ngFor=\"let option of comparatorTypes \" [value]=\"option.key \">{{option.name}}</option> </select> <select class=\"sign-select\" name=\"bVariable\" [(ngModel)]=\"wordCondition.realtionVariableValue.valueType\" (change)=\"onChangedBVariableType($event.target.value)\"> <option *ngFor=\"let option of variableTypes \" [value]=\"option.key \">{{option.name}}</option> </select> <div *ngIf=\"wordCondition.realtionVariableValue.valueType==0\"> <input type=\"number \" name=\"constantBValue \" [(ngModel)]=\"wordCondition.realtionVariableValue.constValue\" class=\"variable-input\"> <i class=\"i-required\">*</i> </div> </div> </div> <div class=\"variable-selector\" *ngIf=\"wordCondition.relationType!=0 && wordCondition.realtionVariableValue.valueType==1\"> <variable-selector [(currentVariableId)]=\"currentRelationVariableId\" [dataType]=\"dataType\" [readWriteModel]=\"readModel\"></variable-selector> <i class=\"i-required variable-selector-i\">*</i> </div> </div>"
        }),
        __param(4, Inject(VARIABLE_SERVICE))
    ], WordConditionComponent);
    return WordConditionComponent;
}(ConfigureComponentBase));
export { WordConditionComponent };
